import React, {useCallback} from 'react';
import {useChatWithUserPathname} from '../../../../../../../data/hooks/chat/useChatWithUserPathname';
import {useI18n} from '../../../../../../../data/hooks/i18nHooks';
import {useMyUserId} from '../../../../../../../data/hooks/sessionHooks';
import resolvePath from '../../../../../../../misc/resolvePath';
import ContainedImage from '../../../../../../elements/ContainedImage';
import styles from '../BubbleMenu.module.scss';

const Chat = props => {
    const {event, user} = props,
        myUserId = useMyUserId(),
        i18n = useI18n(),
        chatPathname = useChatWithUserPathname(user.user_id ?? user.id);

    const handleOpenChat = useCallback(() => {
        if (event && user) {
            app.history.push(resolvePath(['/', 'events', event.id].join('/'), chatPathname));
        }
    }, [event, user]);

    if (!event || !user) return null;
    if (user.user_id === myUserId) return null;
    if (!user.pref_available_for_chat) return null;

    return (
        <button type="button" onClick={handleOpenChat}>
            <span className={styles.label}>{i18n['doubleFavo.hello']}</span>
            <ContainedImage src="/img/eventchat.png" color="white" />
        </button>
    );
};

export default Chat;
